import { Navigate, useOutletContext } from 'react-router-dom';
import type { AppLayoutContext } from '~/types';

export function AppIndexRedirect() {
  const { roleContext } = useOutletContext<AppLayoutContext>();
  const role = roleContext?.selectedRole;

  if (role === 'TEACHER') {
    const yearSlug = roleContext.selectedSchoolYear?.slug;
    // Assigned teachers always have an accessible year. During the initial
    // role-selection render, wait for that year instead of briefly navigating
    // them to an admin-only route.
    if (!yearSlug) return null;
    return <Navigate to={`years/${yearSlug}/teaching`} replace />;
  }

  const target = role === 'PRIMARY_FAMILY_MEMBER' ? 'family' : 'dashboard';
  return <Navigate to={target} replace />;
}
